export default [
  {
    title: 'Home',
    icon: 'HomeIcon',
    route: 'dashboard',
    Permission: '',
  },
  {
    title: 'Files',
    route: 'file-list',
    icon: 'FolderIcon',
    Permission: '',
  },
  {
    title: 'Users',
    icon: 'UsersIcon',
    Permission: 'see_user_menu',
    route: 'user-list',
  },

  {
    title: 'Sign Out',
    route: 'signout',
    icon: 'LogOutIcon',
    Permission: '',
  },
];
